<template>
  <div>
    <span class="default-title" style="font-size: 16px">{{$t('lang.ConfigSetting.basicConfiguration')}}</span>
    <el-table :data="defaultList" strip border width="100%" style="margin-top: 10px" >
      <el-table-column :label="$t('lang.ConfigSetting.protection')">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.options.syn_flood">{{$t('lang.ConfigSetting.Enable')}}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.ConfigSetting.Dropinvalidpackets')">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.options.drop_invalid">{{$t('lang.ConfigSetting.drop')}}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.ConfigSetting.Input')">
        <template slot-scope="scope">
          <el-select
            :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
            v-model="scope.row.options.input"
            size="mini"
            class="Form-Input-Width">
            <el-option v-for="item in SList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.ConfigSetting.Output')">
        <template slot-scope="scope">
          <el-select
            :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
            v-model="scope.row.options.output"
            size="mini"
            class="Form-Input-Width">
            <el-option v-for="item in SList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.ConfigSetting.Forward')">
        <template slot-scope="scope">
          <el-select
            :placeholder="$t('lang.ConfigSetting.Forward')"
            v-model="scope.row.options.forward"
            size="mini"
            class="Form-Input-Width">
            <el-option v-for="item in SList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ['defaultList'],
  data() {
    return {
      SList: [
        { value: "ACCEPT", label: this.$t("lang.ConfigSetting.accept") },
        { value: "REJECT", label: this.$t("lang.ConfigSetting.reject") },
        { value: "DROP", label: this.$t("lang.ConfigSetting.drop") }
      ],
      loading: true
    }
  },
  watch:{
    "defaultList": {
      immediate: true,
      handler: function(newVal){
        if(this.defaultList.length > 0){
          this.defaultList.forEach((item) => {
            if(item.options.syn_flood === '1' || item.options.syn_flood) {
              item.options.syn_flood = true
            }else{
              item.options.syn_flood = false
            }
            if(item.options.drop_invalid === '1' || item.options.drop_invalid) {
              item.options.drop_invalid = true
            }else{
              item.options.drop_invalid = false
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped>

</style>